import { NcoJSONRAW } from '@metservicedev/ncojs/dist/Model/NcoJSON';

export const identifyKeyDimensions = (ncoJson: NcoJSONRAW) => {
    const latDimensionKey = Object.keys(ncoJson.dimensions).find((variableKey) => variableKey.includes('lat'));
    const lonDimensionKey = Object.keys(ncoJson.dimensions).find((variableKey) => variableKey.includes('lon'));
    const depthDimensionKey = Object.keys(ncoJson.dimensions).find(
        (variableKey) => variableKey.includes('depth') || ncoJson.variables[variableKey]?.attributes?.standard_name === 'depth'
    );
    const levelDimensionKey = Object.keys(ncoJson.dimensions).find((variableKey) => variableKey.includes('level'));
    const dateDimensionKey = 'time';
    const dateVariable = ncoJson.variables[dateDimensionKey];

    if (!latDimensionKey || !lonDimensionKey || !dateVariable) {
        console.log({ latDimensionKey, lonDimensionKey, dateVariable });
        throw new Error('Could not find lon, lat, time dimensions');
    }

    return {
        latDimensionKey,
        lonDimensionKey,
        dateDimensionKey,
        depthDimensionKey,
        levelDimensionKey,
    };
};

export const getHeaders = (variableUnitMap: Record<string, string[]>) => {
    const headers = Object.entries(variableUnitMap)
        .map(([variableKey, units]) => {
            return units.map((u) => variableKey + ':' + u);
        })
        .flat();

    return headers;
};
